import { ChangeDetectionStrategy, Component, OnInit, inject } from "@angular/core";
import { map, combineLatest } from "rxjs";
import { LocalizationService } from "../../../../_core/services/localization.service";

@Component({
	selector: 'app-language-selector',
	templateUrl: './language-selector.component.html',
	styleUrls: ['language-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectorComponent {
	localizationService = inject(LocalizationService);

	selectedLocaleCode$ = this.localizationService.localeCode$;
	locales$ = this.localizationService.locales$;

	private selectedLocale$ = combineLatest([
		this.selectedLocaleCode$,
		this.locales$,
	]).pipe(
		map(([selectedLocaleCode, locales]) => locales.find(locale => locale.code ===selectedLocaleCode))
	);

	selectedLanguageName$ = this.selectedLocale$.pipe(
		map(locale => locale ? locale.name : '')
	);

	changeLanguage(code: string) {
		this.localizationService.setLocaleCode(code);
	}
}